<header>
    <nav class="navbar navbar-expand-lg bg-body-tertiary">
        <div class="container-fluid">
            <button
                *ngIf="isSmallScreen"
                class="navbar-toggler d-lg-inline-block"
                type="button"
                (click)="toggleSidenav()">
                <i class="icon-menu-01"></i>
            </button>

            <a
                class="navbar-brand"
                href="https://energies-demain.com/"
                target="_blank"
                title="energies-demain.com"
                [ngClass]="{ 'me-0': isSmallScreen }">
                <img src="/assets/img/logo_header.png" alt="logo" height="40" />
                <h4 class="project-name" *ngIf="!isSmallScreen">{{ projectName }}</h4>
            </a>

            <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed">
                <i class="bi bi-three-dots"></i>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav" [ngbCollapse]="isCollapsed">
                <div class="me-auto align">
                @if(loggedUser.isAdmin){
                        <label for="forceReloadSwitch" *ngIf="!isSmallScreen">Actualisation forcée</label>
                        <br/>  
                        <ed-switch
                        id="forceReloadSwitch"
                        [(ngModel)]="forceReload"       
                        size="large"
                        class="text-centered"
                        (checkedChange)="updateForceReload($event)"></ed-switch>
                }
                    
                </div>
                <div class="profile">
                    <div mat-icon-button [matMenuTriggerFor]="menu">
                        @if (avatarUrl$ | async; as avatarUrl) {
                            <img [src]="avatarUrl" width="40" height="40" alt="avatar" />
                        } @else {
                            <div class="circle">
                                <span class="initials">
                                    {{ initials$ | async }}
                                </span>
                            </div>
                        }
                    </div>

                    <mat-menu #menu="matMenu" class="header-dropdown">
                        <button mat-menu-item class="user-info">
                            <div>
                                @if (avatarUrl$ | async; as avatarUrl) {
                                    <img [src]="avatarUrl" width="40" height="40" alt="avatar" />
                                } @else {
                                    <div class="circle">
                                        <span class="initials">
                                            {{ initials$ | async }}
                                        </span>
                                    </div>
                                }
                            </div>
                            <div>
                                <div class="primary-info">
                                    {{ loggedUser.firstname }} {{ loggedUser.lastname }}
                                </div>
                                <div class="secondary-info">
                                    {{ loggedUser.mail }}
                                </div>
                            </div>
                        </button>

                        <button mat-menu-item routerLink="/main/account" class="btn-cta">
                            <i class="icon icon-user-01"></i>
                            <span>Mon profil</span>
                        </button>

                        @if (loggedUser.isAdmin) {
                            <button mat-menu-item routerLink="/admin/organization" class="btn-cta">
                                <i class="icon icon-tool-01"></i>
                                <span>Administration</span>
                            </button>
                        }
                        <button mat-menu-item (click)="logOut()" class="btn-cta">
                            <i class="icon icon-log-out-01"></i>
                            <span>Déconnexion</span>
                        </button>
                    </mat-menu>
                </div>
            </div>
        </div>
    </nav>
</header>
